import React, { FC } from 'react';
import { Typography, Box } from '@mui/material';
import { Typography700, BreadcrumbsV2 } from 'views/rebranded-module/common/components';

const PageTitleSection:FC<any> = (props) => {
  const { pageTitle, breadcrumbsObject } = props;
  return (
    <Box mt={{ md: 0, lg: 2 }}>
      <Typography700
        component="h1"
        variant="h6"
        mb={2}
        dangerouslySetInnerHTML={{
          __html: pageTitle.title,
        }}
      />
      <Typography
        component="h2"
        variant="body2"
        color="text.secondary"
        mb={2}
        dangerouslySetInnerHTML={{
          __html: pageTitle.subTitle,
        }}
      />
      <BreadcrumbsV2 data={breadcrumbsObject} />
    </Box>
  );
};

export { PageTitleSection };
